import { render, staticRenderFns } from "./PofPieChart.vue?vue&type=template&id=47f7cf3e&scoped=true"
import script from "./PofPieChart.vue?vue&type=script&lang=js"
export * from "./PofPieChart.vue?vue&type=script&lang=js"
import style0 from "./PofPieChart.vue?vue&type=style&index=0&id=47f7cf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7cf3e",
  null
  
)

export default component.exports